import { LangObject } from "@brg/api";

const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    if (value === "") {
        return [
            { lang: 'ru', name: '' },
            { lang: 'en', name: '' }
        ];
    }
    const engValue = current.find(({ lang }) => ['en', 'En']?.includes(lang)) ?? {
        lang: 'en',
        name: '',
    };
    const ruValue = current.find(({ lang }) => ['ru', 'Ru']?.includes(lang)) ?? {
        lang: 'ru',
        name: '',
    };

    if (lang === 'ru') {
        return [{
            lang: 'ru',
            name: value,
        }, engValue];
    } else {
        return [ruValue, {
            lang: 'en',
            name: value,
        }];
    }
}

export default setTextByLang;import { LangObject } from "@brg/api";

const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    if (value === "") {
        return [
            { lang: 'ru', name: '' },
            { lang: 'en', name: '' }
        ];
    }
    const engValue = current.find(({ lang }) => ['en', 'En']?.includes(lang)) ?? {
        lang: 'en',
        name: '',
    };
    const ruValue = current.find(({ lang }) => ['ru', 'Ru']?.includes(lang)) ?? {
        lang: 'ru',
        name: '',
    };

    if (lang === 'ru') {
        return [{
            lang: 'ru',
            name: value,
        }, engValue];
    } else {
        return [ruValue, {
            lang: 'en',
            name: value,
        }];
    }
}

export default setTextByLang;